export default __webpack_public_path__ + "static/media/image00033.86ca4307.jpeg";